export default __webpack_public_path__ + "static/media/MargotProgramm.9851c650.png";